// Minimal classname joiner. Falsy values are dropped; later values win only by source
// order (no conflict resolution — keep utility usage non-overlapping). Kept dependency-free.
export type ClassValue = string | number | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values.filter((v) => typeof v === 'string' && v.length > 0).join(' ');
}
